import {Feature} from '../core/models'
import {getDateString} from '../core/helpers'
import {IFeatureLayerInfo} from '../core/interfaces/models'

export const getPlanName = (feature: Feature): string => {
  return `${feature.getProperties()['PlanName']} от ${getDateString(new Date(feature.getProperties()['PlanDate']))}`
}

export const IsValidCadastreFilter = (filter: string): boolean => {
  const split = filter.split('.')
  return (
    split.filter(a => {
      let string = a
      while (string.startsWith('0')) {
        string = string.replace('0', '')
      }
      const int = parseInt(string)
      if (isNaN(int) || string.length != int.toString().length) {
        return false
      }
      return true
    }).length == split.length &&
    split.length > 0 &&
    split[0].length == 5
  )
}

export const CadastreFilterToWhere = (filter: string, featureLayerInfo: IFeatureLayerInfo): string => {
  let where =
    featureLayerInfo.sourceDescription.constantSqlWhere && featureLayerInfo.sourceDescription.constantSqlWhere != '1=1'
      ? `${featureLayerInfo.sourceDescription.constantSqlWhere}`
      : ''
  if (filter) {
    const split = filter.split('.')
    const segments = {
      ekatte: split[0] ? `'${split[0]}'` : '',
      cadregion: split[1],
      cadimmovable: split[2],
      cadbuilding: split[3],
      cadapp: split[4]
    }
    const results: string[] = []
    for (const key in segments) {
      if ((segments as any)[key]) {
        results.push(`${key}=${(segments as any)[key]}`)
      }
    }
    if (where && results.length > 0) {
      where += ' AND '
    }
    where += results.join(' AND ')
  }

  return where
}
